import { render, staticRenderFns } from "./dashboardRates.vue?vue&type=template&id=32b59580&scoped=true"
import script from "./dashboardRates.vue?vue&type=script&lang=js"
export * from "./dashboardRates.vue?vue&type=script&lang=js"
import style0 from "./dashboardRates.vue?vue&type=style&index=0&id=32b59580&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b59580",
  null
  
)

export default component.exports